import * as types from '../constants/actionConstants';
import { createSingleAction } from '../../utils/reduxActions';

export const getListMyGiftAction = createSingleAction(
  types.loyaltyAccInfoConst.GIFT_GETALL_BYMEMBERCODE
);
export const getListMyGiftActionSuccess = createSingleAction(
  types.loyaltyAccInfoConst.GIFT_GETALL_BYMEMBERCODE_SUCCESS
);

export const getListMyGiftPaAction = createSingleAction(
  types.loyaltyAccInfoConst.GIFT_CREAT_REDEEM_HISTORY
);
export const getListMyGiftPaActionSuccess = createSingleAction(
  types.loyaltyAccInfoConst.GIFT_CREAT_REDEEM_HISTORY_SUCCESS
);
export const getDetailGiftAction = createSingleAction(types.loyaltyAccInfoConst.GIFT_VOUCHE_DETAIL);
export const getDetailGiftActionSuccess = createSingleAction(
  types.loyaltyAccInfoConst.GIFT_VOUCHE_DETAIL_SUCCESS
);

export const getListMyGiftUsedOwnAction = createSingleAction(
  types.loyaltyAccInfoConst.GET_LOYALTY_OWNGIFT_USED
);
export const getListMyGiftUsedOwnActionSuccess = createSingleAction(
  types.loyaltyAccInfoConst.GET_LOYALTY_OWNGIFT_USED_SUCCESS
);
export const getListMyGiftUnusedOwnAction = createSingleAction(
  types.loyaltyAccInfoConst.GET_LOYALTY_OWNGIFT_UNUSED
);
export const getListMyGiftUnusedOwnActionSuccess = createSingleAction(
  types.loyaltyAccInfoConst.GET_LOYALTY_OWNGIFT_UNUSED_SUCCESS
);

export const getAllForCategory = createSingleAction(
  types.loyaltyAccInfoConst.GIFT_GETALL_GETALLFORCATEGORY
);
export const getAllForCategorySuccess = createSingleAction(
  types.loyaltyAccInfoConst.GIFT_GETALL_GETALLFORCATEGORY_SUCCESS
);
export const createRedeemTransactionAction = createSingleAction(
  types.loyaltyAccInfoConst.GIFT_CREAT_REDEEM_TRANSACTION
);
export const createRedeemTransactionActionSuccess = createSingleAction(
  types.loyaltyAccInfoConst.GIFT_CREAT_REDEEM_TRANSACTION_SUCCESS
);

export const updateStatusGiftInforAction = createSingleAction(
  types.loyaltyAccInfoConst.GIFT_INFOR_UPDATE_STATUS
);
export const updateStatusGiftInforActionSuccess = createSingleAction(
  types.loyaltyAccInfoConst.GIFT_INFOR_UPDATE_STATUS_SUCCESS
);

export const getAllWithImage = createSingleAction(
  types.loyaltyAccInfoConst.GIFT_GETALL_GETALLWITHIMAGE
);
export const getAllWithImageSuccess = createSingleAction(
  types.loyaltyAccInfoConst.GIFT_GETALL_GETALLWITHIMAGE_SUCCESS
);

export const getListMenuCategoryAction = createSingleAction(
  types.loyaltyAccInfoConst.GIFT_CATEGORY_GETALL_MENU
);
export const getListMenuCategoryActionSuccess = createSingleAction(
  types.loyaltyAccInfoConst.GIFT_CATEGORY_GETALL_MENU_SUCCESS
);

export const getCityCodeAction = createSingleAction(
  types.loyaltyAccInfoConst.GIFT_MODAL_REDEEM_GIFT_CITYCODE
);
export const getCityCodeActionSuccess = createSingleAction(
  types.loyaltyAccInfoConst.GIFT_MODAL_REDEEM_GIFT_CITYCODE_SUCCESS
);

export const getTownCodeAction = createSingleAction(
  types.loyaltyAccInfoConst.GIFT_MODAL_REDEEM_GIFT_TOWNCODE
);
export const getTownCodeActionSuccess = createSingleAction(
  types.loyaltyAccInfoConst.GIFT_MODAL_REDEEM_GIFT_TOWNCODE_SUCCESS
);

export const getVillageCodeAction = createSingleAction(
  types.loyaltyAccInfoConst.GIFT_MODAL_REDEEM_GIFT_VILLAGECODE
);
export const getVillageCodeActionSuccess = createSingleAction(
  types.loyaltyAccInfoConst.GIFT_MODAL_REDEEM_GIFT_VILLAGECODE_SUCCESS
);

export const getProfileByCGif = createSingleAction(
  types.loyaltyAccInfoConst.LOYALTY_ACC_PROFILE_MEMBER
);
export const getProfileByCGifSuccess = createSingleAction(
  types.loyaltyAccInfoConst.LOYALTY_ACC_PROFILE_MEMBER_SUCCESS
);

export const resetStateAct = createSingleAction(
  types.loyaltyAccInfoConst.GIFT_VOUCHER_RESET_ACC_INFO
);
export const onDisplayToRedeem = createSingleAction(
  types.loyaltyAccInfoConst.GIFT_PASS_DATA_REDEEM
);
export const setChallengeDetail = createSingleAction(types.loyaltyAccInfoConst.CHALLENGE_DETAIL);

export const checkMiniGameAction = createSingleAction(
  types.loyaltyAccInfoConst.GIFT_CHECK_MINIGAME
);
export const checkMiniGameActionSuccess = createSingleAction(
  types.loyaltyAccInfoConst.GIFT_CHECK_MINIGAME_SUCCESS
);
